import Head from 'react-helmet';

import { structuredData } from './StructuredData';

const TITLE = 'Zillow Rent Estimate Calculator | Zillow Rental Manager';
const DESCRIPTION =
  'Determine your rent estimate and find out how much rent to charge with the Zillow Rent Zestimate® Calculator for free from Zillow Rental Manager.';
const METAS = [{ name: 'description', content: DESCRIPTION }];

const PageHead = ({ canonicalURL }: { canonicalURL: string }) => {
  const link = [];
  if (canonicalURL) {
    link.push({
      rel: 'canonical',
      href: canonicalURL,
    });
  }
  return <Head title={TITLE} meta={METAS} script={structuredData} link={link} />;
};

export default PageHead;
